/* Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NvHigListItemContextData } from '../../../models/hig-list-item.types';

@Component({
    selector: 'nv-hig-list-item-context',
    templateUrl: './nv-hig-list-item-context.component.html',
    styleUrl: './nv-hig-list-item-context.component.scss',
    imports: [MatIconModule, TranslateModule]
})
export class NvHigListItemContextComponent {
    data: NvHigListItemContextData;
    @Input() set cardData(x: NvHigListItemContextData) {
        this.data = x;
    }
}
